export default {
  "meeting": {
    applyrecurring: 'Изменения будут применены к новому повторяющемуся расписанию. Прошедшие встречи останутся без изменений.',
    recurrenceDescribeTwo: 'Повторяется каждые {loopPulse} недель по {week}, начиная с {start} до {end}',
    wanttodeletethemeetingfollowTwo: 'Удалить выбранную встречу и все последующие повторяющиеся встречи?',
    loopCycleSelectTips: 'Выберите день недели для повторения.',

    export: 'Экспорт',
    exportMeetingFileFuncTipsTitle: 'Подтверждение экспорта',
    exportMeetingFileFuncTipsContentOne: 'Фильтры не применены. По умолчанию система экспортирует записи встреч за текущий год.',
    exportMeetingFileFuncTipsContentTwo: 'Чтобы экспортировать встречи за другой период, примените нужные фильтры перед экспортом.',

    myMeetingSearch: 'Мои встречи',
    meetingTimeSearch: 'Время встречи',
    meetingRoomsSearch: 'Переговорная комната',

    Recurring: 'Повторение:',
    wanttodeletethemeetingfollow: 'Вы уверены, что хотите удалить эту встречу и все последующие встречи?',
    endTimeCannotBeforeBeginTime: 'Дата окончания не может быть раньше даты начала',
    Thismeeting: 'Эта встреча',
    Recurringmeeting: 'Повторяющаяся встреча',
    Checkin: 'Регистрация:',
    checkinTip: 'После включения участники могут зарегистрироваться, отсканировав QR-код планировщика переговорных комнат.',
    Recurrence_Setrecurrence: 'Настроить повторение',
    Recurrence_Start: 'Начало',
    Recurrence_RepeatEvery: 'Повторять каждые',
    Recurrence_Week: 'Неделя',
    Recurrence_end: 'Конец',
    recurrenceDescribe: 'Повторяется каждые {week} с {start} до {end}',
    Recurrence_DoesnotRepeat: 'Не повторять',
    Recurrence_Weekly: 'Еженедельно',

    AddressBookUser: 'Пользователь',
    AddressBookPhonebook: 'Адресная книга',

    RoomByPeopleNum1: '2 человека или меньше',
    RoomByPeopleNum2: '3-6 человек',
    RoomByPeopleNum3: '7-10 человек',
    RoomByPeopleNum4: '11-15 человек',
    RoomByPeopleNum5: '16-20 человек',
    RoomByPeopleNum6: '21-30 человек',
    RoomByPeopleNum7: 'Более 30 человек',

    whoAreBound: 'Пользователи, привязанные к системной учетной записи, увидят встречу в системном календаре. Пользователи, указавшие электронную почту, получат уведомления по почте. Чтобы получать уведомления, заполните данные в разделе [Мой профиль].',

    AttendessMeeting: 'Участники:',
    SelectAttendessMeetingTip: 'Выбрать участников',

    MeetingFilter: 'Фильтр встреч',
    HostedbyMe: 'Организовано мной',
    Invitedby: 'Я участник',
    Otherby: 'Другие',

    "AddressIsDuplicated": "Электронная почта контакта дублируется",
    "meetingExpired": "Истекло",
    titlePhoneFormat: 'Телефон может содержать только цифры, () + и -.',
    "selectField": "Выберите файл",
    "Limit255": "Имя файла не может превышать 255 символов",
    "nameLimit25": "Имя не может превышать 25 символов",
    "emailLimit50": "Email не может превышать 50 символов",
    "emailFormatError": "Введите корректный адрес электронной почты",
    "phoneLimit11": "Номер телефона может содержать до 11 цифр",
    "ParticipantsEmail": "Email участника:",
    "listIsEmpty": "Список пуст",
    "Startimporting": "Начать загрузку",
    "Selectfile": "Выбрать файл",
    "Importfile": "Импортировать файл",
    "ImportfileTip": "*Поддерживается импорт только файлов CSV формата Outlook (.csv) или vCard (.vcf).",
    "addParticipants": "Добавить участника",
    "multiselectdeselect": "Подсказка удаления ярлыка",
    "multiselectselected": "Подсказка выбора",
    "enterOrSelectALabel": "Выберите email участника",
    "deleTitleContact": "Вы уверены, что хотите удалить этот контакт?",
    "delTitleContactContent": "Удалить контакт?",
    "deleteContactTitle": "Выберите контакт для удаления",
    "editcontact": "Редактировать контакт",
    "Name": "Имя",
    "email": "Email",
    "telephoneNumber": "Телефон",
    "Addcontact": "Добавить контакт",
    "Importcontactfile": "Импортировать контакты",
    "AddressBook": "Адресная книга",
    "Participants": "Участники:",

    bindTipContent:"Эта организация уже привязала календарь стороннего сервиса. Пожалуйста, назначайте встречи через Outlook/Teams.",
    Productupdatenews: 'Выпущено новое обновление версии. ',
    bookingPerson: 'Забронировано',
    "DeleteMeeting": "Удалить встречу",
    "wanttodeletethemeeting": "Вы хотите удалить встречу?",
    "hasbeendeleted": "Встреча была удалена",
    "theMeetingWasAborted": "Завершить встречу досрочно",
    "theMeetingWasAbortedContent": "Вы хотите завершить встречу досрочно?",
    "determineTheAbortTask": "Завершить встречу досрочно",
    "theMeetingEndedEarly": "Встреча была завершена досрочно.",
    "with": "с",
    "Other": "Другое",
    "tasks": "конфликт задач",
    "conflict": "Следующее время встречи конфликтует:",
    "meetConflicts": "Прошлые времена не могут быть выбраны",
    "itIsNotAllowedToSelectThePastTime": "Выбрано",
    "selected": "Выберите не более 5 залов для совещаний",
    "noOverFive": "Мнение по утверждению",
    "approvalOpinions": "По истечении времени нельзя выбрать",
    "beyondTheTimeLimitItCannotBeSelected": "Месяц начала",
    "startMonth": "до",
    "to": "Месяц окончания",
    "stopMonth": "Без начала",
    "didnTStart": "В процессе",
    "ONGOING": "Завершено",
    "ENDED": "уже было",
    "hasBeen": "бронирование",
    "booking": "Утверждение",
    "Approval": "Конференц-зал",
    "MeetingRoom": "Все комнаты",
    "AllRoom": "Доступно",
    "Available": "Инициировать встречу",
    "Initiate": "Утверждение встречи",
    "MeetingApproval": "Предыдущий месяц",
    "PreviousMonth": "Сегодня",
    "Today": "Следующий месяц",
    "NextMonth": "Год/Месяц",
    "YearMonth": "Отображение времени",
    "TimeDisplay": "Сокращение названия встречи",
    "MeetingTitleAbbreviation": "Инициировать встречу",
    "InitiateMeeting": "Предстоящие встречи",
    "PendingMeetings": "Все встречи",
    "AllMeetings": "На данный момент нет встреч для посещения",
    "noMeetings": "Не начато",
    "NotStarted": "Организатор",
    "Organizer": "Дата и время",
    "MeetingDateTime": "Место",
    "MeetingLocation": "Тема встречи",
    "MeetingSubject": "Приглашенные",
    "Invited": "Принявшие участие",
    "PeopleAccepted": "Редактировать встречу",
    "EditMeeting": "Отменить встречу",
    "CancelMeeting": "Инициировать/Редактировать встречу",
    "InitiateEditMeeting": "Тема",
    "Subject": "Тема",
    "Presenter": "Презентатор :",
    "DateTime": "Дата и время",
    "TimeAndZone": "Часовой пояс",
    "Attendees": "Участники",
    "Addrequiredattendees": "Добавить обязательных участников",
    "SelectRooms": "Выбрать комнаты",
    "Reminder": "Напоминание",
    "Remindbeforestart": "Напомнить до начала",
    "Confirm": "Подтвердить",
    "topic": "Тема :",
    "topicplace": "Новое название встречи :",
    "speaker": "Презентатор :",
    "speakerplace": "Пожалуйста, введите информацию о презентаторе",
    "DateAndTime": "Дата и время :",
    "TimeZone": "Часовой пояс",
    "EndDate": "Дата окончания",
    "Rooms": "Комнаты :",
    "Notes": "Заметки :",
    "MeetingRoomApproval": "Одобрение комнаты для встречи",
    "PendingApproval": "Ожидает одобрения",
    "Approved": "Одобрено",
    "nopendingapprovals": "Нет ожидающих одобрений",
    "Applicant": "Заявитель",
    "UsageTime": "Время использования",
    "ApprovalResult": "Результат одобрения",
    "ApprovalComments": "Комментарии по одобрению",
    "Approve": "Одобрить",
    "Reject": "Отклонить",
    "Search": "Поиск",
    "Filter": "Фильтр",
    "scanTheQRCodeToSignIn": "Отсканируйте QR-код, чтобы зарегистрироваться"
  },
  "NPS": {
    "Relay": "Реле",
    "RelaySettings": "Настройки реле",
    "DevicePower": "Управление питанием устройства",
    "DeviceElevation": "Управление подъёмом",
    "LinageWithNPSPower": "Связь с питанием NPS",
    "PresentationSwitch": "Переключатель презентации",
    "Duplicate": "Дублировать",
    "LinkagewithNPSPowe": "Связь с питанием NPS",
    "npsTooltip": "USB-устройства могут быть вызваны только ПК-хостом, который переключен на HDMI OUT 1.",
    "nmpTooltip": "Нажмите кнопку 'Дублировать', чтобы отобразить содержимое экрана на других дисплеях, синхронизируя отображение на нескольких экранах."
  },
  "textTemplate": {
    "template2513": "Трансляция экстренной ситуации по пожару",
    "template2514": "Пожалуйста, эвакуируйтесь через аварийный выход и выход для эвакуации при пожаре в безопасное место в соответствии с планом эвакуации при пожаре.",
    "moreTemplate": "Достигнут предел шаблонов",
    "add": "Добавить",
    "SetTemplate": "Установить шаблон",
    "Emergency": "Чрезвычайная ситуация",
    "General": "Общее",
    "BroadcastDevices": "Устройство для трансляции:",
    "selectBroadcastDevices": "Пожалуйста, выберите устройства для трансляции",
    "All": "Все",
    "AddTemplate": "Добавить шаблон",
    "EditTemplate": "Редактировать шаблон",
    "deleteTemplage": "Вы уверены, что хотите удалить выбранный шаблон?",
    "title": "Удалить шаблон",
    "selectTemplage": "Пожалуйста, выберите шаблон!",
    "DeleteCancelled": "Удаление отменено!",
    "DeletedSuccessfully": "Успешно удалено!",
    "noData": "Шаблон не может быть использован, нажмите на правый верхний угол, чтобы добавить шаблон.",
    "TemplateTitle": "Название шаблона:",
    "BroadcastType": "Тип трансляции:",
    "BroadcastTypeDialog": "Тип трансляции:",
    "selectBroadcastType": "Пожалуйста, выберите тип трансляции",
    "BroadcastDuration": "Продолжительность трансляции:",
    "BroadcastDevice": "Устройство для трансляции:",
    "BroadcastContent": "Контент трансляции:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "Ошибка!",
    "mediaTimeStateNotifyErrorContent": "Ваш сервис потоковой передачи истек, пожалуйста, свяжитесь с вашим агентом для своевременного продления.",
    "mediaTimeStateNotifyWarnTitle": "Внимание!",
    "mediaTimeStateNotifyWarnContent": "В настоящее время вы находитесь в пробном режиме, который позволяет передавать и транслировать потоковое видео только на 3 устройства.",
    "mediaTimeStateNotifySuccessTitle": "Успешное продление",
    "mediaTimeStateNotifySuccessContent": "Ваш сервис потоковой передачи готов к нормальному использованию. Спасибо.",
    "company": "Название компании:",
    "tableAddress": "Адрес:",
    "createTime": "Дата создания:",
    "email": "Электронная почта:",
    "phone": "Телефон:",
    "Trial": "Пробный",
    "TrialWorkstation": "В настоящее время вы находитесь в пробном режиме, который позволяет передавать и транслировать потоковое видео только на 3 устройства.",
    "Normal": "Нормальный",
    "NormalWorkstation": "Срок действия вашего сервиса потоковой передачи с",
    "to": "по",
    "Advent": "Скоро",
    "AdventWorkstationOne": "Ваш сервис потоковой передачи истечет",
    "AdventWorkstationTwo": ", пожалуйста, свяжитесь с вашим агентом для его продления своевременно для нормального использования.",
    "Expired": "Истекло",
    "ExpiredWorkstation": "Ваш сервис потоковой передачи истек, пожалуйста, свяжитесь с вашим агентом для его продления."
  },
  "route": {
    "dashboard": "Панель управления",
    "i18n": "I18n",
    "Devices": "Устройства",
    "Broadcast": "Трансляция",
    "Schedule": "Расписание",
    "Resources": "Ресурсы",
    "Live": "Стриминг",
    "meetings": "Встреча"
  },
  "navbar": {
    "updates":"Последние обновления",
    "logOut": "Выйти",
    "screenfull": "на весь экран",
    "oprofile": "Мой профиль",
    "settings": "Настройки",
    "language": "Язык",
    "BackTianwa": "Назад в Tianwa",
    "newUserGuide": "Руководство для новых пользователей"
  },
  "feedback": {
    "Feedback": "Обратная связь",
    "email": "Please leave your email for our feedback.",
    "content": "Добро пожаловать и оставляйте сообщения для улучшения наших продуктов. Спасибо за ваши комментарии.",
    "submit": "Отправить",
    "emailNoEmpty": "Электронная почта не может быть пустой",
    "emailTrueRule": "Пожалуйста, введите правильный формат электронной почты",
    "contentNoEmpty": "Содержание не может быть пустым",
    "feedbackSuccess": "Обратная связь успешна",
    "feedbackFailed": "Ошибка обратной связи",
    "emailNoChinese": "Адрес электронной почты не может содержать китайские символы",
    "emailLength": "Длина от 5 до 50 символов",
    "emailSpecialString": "Адрес электронной почты не может содержать специальные строки"
  },
  "login": {
    checkPasswordTitleTwo: 'Установите пароль длиной не менее 6 символов, содержащий буквы и цифры. Специальные символы разрешены (без ограничений).',
    captcha: 'Код подтверждения',
    checkPasswordTitle: 'Пароль должен содержать не менее 6 символов и не может состоять только из цифр',
    "title": "ДОБРО ПОЖАЛОВАТЬ",
    "logIn": "Войти",
    "consoleLogin": "Вход в консоль",
    "username": "Имя пользователя",
    "password": "Пароль",
    "any": "любой",
    "thirdparty": "Или войдите с",
    "thirdpartyTips": "Не может быть смоделировано локально, поэтому комбинируйте с вашей собственной бизнес-симуляцией!",
    "placeholder": ["Имя пользователя","Пароль","Код подтверждения"],
    "userNameTitle": "Неправильное имя пользователя!",
    "forget": "Забыли?",
    "loginTitle0": "Успешный вход!",
    "loginTitle1000": "Неправильное имя пользователя или пароль!",
    "loginTitle1001": "Имя пользователя и пароль должны быть заполнены!",
    "loginTitle1002": "Код подтверждения должен быть заполнен!",
    "loginTitle1003": "Статус пользователя незаконен, вход не удался!",
    "loginTitle1004": "Ошибка кода подтверждения!",
    "loginTitle1005": "Не выполнен вход, пожалуйста, выполните вход сначала!",
    "loginTitle1006": "Пароли не совпадают!",
    "loginTitleUserName": "Имя пользователя должно быть заполнено!",
    "loginTitlePwd": "Пароль должен быть заполнен!",
    "loginTitleVercode": "Код подтверждения должен быть заполнен!",
    "titleLoginNameFormat": "Аккаунт должен состоять из символов или символов и цифр.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "Устройства",
    "btnRoadcast": "Трансляция",
    "btnResources": "Ресурсы",
    "btnLive": "Стриминг",
    "meetings": "Встреча",
    "todaySchedule": "Расписание на сегодня",
    "allSkedules": "Все расписания",
    "details": "Подробности",
    "btnStart": "Начать",
    "titleContent": "Приветствую! Консоль Q-NEX к вашим услугам. Давайте начнем!",
    "btnExit": "Выйти"
  },
  "devices": {
    ptzCamera:'PTZ-камера',
    "start": "НАЧАТЬ",
    "stop": "ОСТАНОВИТЬ",
    "nmpPowerOff_mandatory": "Вещание (необязательное)",
    "nmpPowerOff_nomandatory": "Вещание (необязательное). Продолжить выполнение?",
    "nmpsPowerOff_mandatory": "Некоторые NMP находятся в вещании (обязательное).",
    "nmpsPowerOff_nomandatory": "Некоторые NMP находятся в вещании (необязательное). Продолжить выполнение?",
    "reset": "Сбросить",
    "displayedInTheControlArea": "Отображается в центре управления",
    "dragOrder": "Перетащить порядок",
    "areaSettingTwoNotice": "*Управление RS232, AC и дистанционное управление отображаются в центре управления в зависимости от состояния привязки NMP на панели управления.",
    "areaSettingThreeNotice": "*Управление CBX отображается в центре управления в зависимости от состояния привязки NMP на панели управления.",
    "controlSet": "Настройки центра управления",
    "vcbNoLine": "Нет устройств CBX в сети",
    "vcbNoBound": "Нет привязанных устройств CBX",
    "tscNoBound": "RS232 на TSC не привязан к данным. Пожалуйста, сообщите администратору, чтобы привязать это в панели управления.",
    "light": "Управление питанием",
    "vcbpower": "Питание",
    "rs232Control": "Серийное управление",

    "CBX": {
    "powerSupplyON": "Включить",
    "powerSupplyOFF": "Выключить",
    "lockScreenON": "Заблокировать",
    "lockScreenOFF": "Разблокировать",
    "childLockON": "Режим блокировки детей включен",
    "childLockOFF": "Режим блокировки детей отключен",
    "energySavingON": "Энергосбережение включено",
    "energySavingOFF": "Энергосбережение отключено",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "Динамик",
    "brightAdjustment": "Яркость",
    "other": "Другие функции..."
  },

    "InterfaceOne": "Интерфейс Один",
    "InterfaceTwo": "Интерфейс Два",
    "abcStyleP": "Извините! TSC и (NMP, MBX, NPS, NDP100, NDP500) не могут быть выбраны одновременно",
    "masterControl": "основной",
    "powerSupply": "Питание",
    "RecordingControl": "Управление записью",
    "RecordingControlSystem": "Система захвата лекций",
    "LiquidCrystal": "Интерактивный ЖК-дисплей",
    "projector": "Проектор",
    "othertype": "Другое",
    "lockScreen": "Блокировка",
    "childLock": "Блокировка детей",
    "energySaving": "Энергосбережение",
    "signalSourceSwitching": "Источник входа",
    "volumeAdjustment": "Динамик",
    "brightAdjustment": "Яркость",
    "other": "Другие функции",
    "otherFunction": "Функция",
    "send": "Отправить",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "Кондиционер",
    "titleDevices": "Фильтр групп:",
    "content": "Поиск",
    "selectALL": "Выбрать ВСЕ",
    "SelectRecentPage": "Выбрать текущую страницу",
    "controlPanel": "Центр управления",
    "displayInputSwitch": "Переключатель входа дисплея",
    "chooseINPUTSources": "Выберите источники ВХОДА",
    "speakerVolume": "Громкость аудио",
    "bass": "Низкие частоты",
    "treble": "Высокие частоты",
    "MICVolume": "Громкость микрофона",
    "AirConditioning": "Кондиционер",
    "model": "Модель",
    "setTemp": "Установленная температура",
    "fanSpeed": "Скорость вентилятора",
    "bold": "Колебания",
    "projectionScreen": "Экран проекции",
    "electronicLock": "Электрический замок",
    "electronicLock1": "Электрический замок",
    "selectDevices": "Пожалуйста, выберите устройство или группу устройств",
    "isCompelType": "Управление устройством недоступно из-за обязательной трансляции, пожалуйста, повторите попытку позже.",
    "mainPower": "Основное питание",
    "extraPower": "Дополнительное питание",
    "power": "Питание",
    "hdmiBroadcast": "Трансляция",
    "equipmentState1": "Включить",
    "equipmentState2": "Выключить",
    "equipmentState3": "Офлайн",
    "main": "Основной",
    "external": "Внешний",
    "ProjectionScreen": "Экран проекции",
    "UP": "ВВЕРХ",
    "DOWN": "ВНИЗ",
    "LOCK": "ЗАБЛОКИРОВАТЬ",
    "UNLOCK": "РАЗБЛОКИРОВАТЬ",
    "PleaseDevice": "Пожалуйста, выберите устройство(а) слева",
    "RemoteControl": "Удаленное управление",
    "Action": "Действие",
    "Devicefilter": "Фильтр устройств",
    "DeviceStatus": "Статус",
    "DeviceType": "Тип",
    "currentAudioSource": "Текущий источник аудио",
    "audioSwitching": "Переключатель аудиовыхода"
  },
  "broadcast": {
    "isBoarding": "(В трансляции)",
    "last3Days": "ПОСЛЕДНИЕ 3 ДНЯ",
    "last7Days": "ПОСЛЕДНИЕ 7 ДНЕЙ",
    "last30Days": "ПОСЛЕДНИЕ 30 ДНЕЙ",
    "historyRecord": "История",
    "SelectDestination": "1.Выберите пункт назначения",
    "BroadcastingConsole": "2.Пульт управления трансляцией",
    "Notification": "Уведомление",
    "btnStop": "Остановить",
    "btnStart": "Начать",
    "Letters60": "(менее 60 символов)",
    "Letters300": "(менее 300 символов)",
    "LastingTime": "Продолжительность:",
    "Title": "Заголовок:",
    "Content": "Содержание:",
    "Cannotquit": "Обязательная трансляция",
    "ChooseMedia": "Выберите медиафайл",
    "Broadcasting": "Трансляция",
    "dialogTitle": "Ресурсы видео и аудио",
    "SortBy": "эрэмбэ",
    "btnBake": "Назад",
    "cancel": "Отменить",
    "confirm": "Подтвердить",
    "save": "Сохранить",
    "coxAll": "Все",
    "PublicCloud": "Общественное хранилище",
    "IndividualCloud": "Личное хранилище",
    "selFile": "Пожалуйста, выберите файл или группу.",
    "StopBroadcast": "Остановить трансляцию",
    "StartBroadcasting": "Начать трансляцию",
    "StopBroadcasting": "Остановить трансляцию",
    "ForceQuit": "Принудительное завершение",
    "PleaseMediaFile": "Пожалуйста, выберите медиафайл",
    "PleaseDevice": "Пожалуйста, выберите устройство",
    "broadcast_0": "Начать трансляцию",
    "broadcast_2500": "Превышено максимальное количество подключаемых устройств для медиасервера",
    "broadcast_2501": "Ошибка файла трансляции",
    "broadcast_2502": "Трансляция завершена",
    "broadcast_2503": "Не удалось получить информацию от медиасервера",
    "broadcast_2510": "Внимание! Вы находитесь в режиме пробной версии, до 3 терминальных устройств могут получать команды трансляции. Пожалуйста, проверьте количество выбранных вами устройств.",
    "broadcast_2018": "Сервис трансляции отключен.",
    "broadcast_2019": "Срок действия сервиса трансляции истек.",
    "broadcast_2512": "Превышен лимит количества шаблонов.",
    "broadcast_2513": "Трансляция чрезвычайной ситуации с пожаром.",
    "broadcast_2514": "Пожалуйста, эвакуируйтесь через аварийный выход и выход для эвакуации в безопасное место согласно плану эвакуации при пожаре.",
    "broadcast_2006": "Устройство не найдено.",
    "broadcast_2": "Сервис диска неисправен.",
    "broadcast_2515": "Выберите устройство, которое не имеет функции трансляции.",
    "broadcast_2516": "Выберите файлы, которые превышают максимальное поддерживаемое разрешение NMP.",
    "broadcast_2517": "Выберите файлы, которые превышают максимальное поддерживаемое разрешение NDP500.",
    "broadcast_Title": "Предупреждение трансляции.",
    "broadcast_TitleNDP500": "Предупреждение трансляции NDP500.",
    "broadcast_content": "Устройство поддерживает до 4K@30FPS с оптимальным разрешением 1080P@30FPS.",
    "broadcast_contentNDP500": "NDP500/600 поддерживает до 1080P@30FPS с оптимальным разрешением 720P@30FPS.",
    "broadcast_noSupported": "Следующие выбранные видео не поддерживаются для трансляции:",
    "broadcast_noSupportedNDP500": "Следующие выбранные видео не поддерживаются для трансляции на NDP500/600:"
  },
  "resources": {
    "uploadNameLengthError": "Имя загружаемого файла не может превышать 100 слов!",
    "onUploadFile": "Нет файлов для загрузки",
    "open": "Открыть",
    "fold": "Свернуть",
    "close": "Закрыть",
    "PublicCloud": "Общий накопитель",
    "IndividualCloud": "Личный накопитель",
    "TransfersHistory": "История переданных файлов",
    "btnDownload": "Скачать",
    "btnDelete": "Удалить",
    "btnUploadFile": "Загрузить файл",
    "btnNewFolder": "Новая папка",
    "btnBake": "Вернуться к предыдущему",
    "coxAll": "Все",
    "uploadError": "Размер загружаемого файла не может превышать 1 ГБ!",
    "MD5": "Проверка MD5",
    "merge": "Объединение",
    "transcoding": "Транскодирование",
    "uploadFailed": "Ошибка загрузки",
    "fileError": "Ошибка чтения файла, пожалуйста, проверьте файл.",
    "tableName": "Имя",
    "tableSize": "Размер",
    "tableType": "Тип",
    "tableTimeAdded": "Время добавления",
    "tableAction": "Действие",
    "btnRename": "Переименовать",
    "btnMoveTo": "Переместить в...",
    "ClearAll": "Очистить все",
    "cancel": "Отмена",
    "confirm": "Подтвердить",
    "save": "Сохранить",
    "addSuccess": "Успешно добавлено!",
    "addError": "Не удалось добавить!",
    "editSuccess": "Успешно отредактировано!",
    "editError": "Ошибка редактирования!",
    "delSuccess": "Удалено успешно!",
    "delError": "Ошибка удаления!",
    "diskError3000": "Превышен общий размер пространства, операция не выполнена!",
    "diskError3001": "Превышено использование публичного пространства, операция не выполнена!",
    "diskError3002": "Превышено использование личного пространства, операция не выполнена!",
    "diskError3003": "Не удается найти данные, проверьте, связан ли медиасервер!",
    "diskError3004": "Имя папки уже существует!",
    "diskError3005": "Не удалось получить папку!",
    "diskError3006": "На одном уровне нельзя создать более 99 папок!",
    "diskError3007": "Имя файла уже существует, изменение не выполнено!",
    "diskError3008": "Имя папки уже существует, изменение не выполнено!",
    "diskError3009": "Файл превышает оставшееся пространство, загрузка не удалась!",
    "diskError3010": "Не удалось загрузить!",
    "diskError3011": "Ошибка проверки файла, пожалуйста, загрузите файл снова!",
    "diskError3012": "Не удалось получить адрес частного облака, операция не выполнена!",
    "diskError3013": "Комбинированные файлы не могут превышать 100 МБ, большие файлы загружайте отдельно!",
    "diskError3014": "Ошибка сжимающей операции, выберите файл для загрузки заново!",
    "diskError3015": "Для выполнения этой операции нужны разрешения",
    "downloadError": "Ошибка загрузки!",
    "mobileError": "Ошибка перемещения!",
    "root": "Все файлы",
    "Name": "Имя",
    "Size": "Размер",
    "Type": "Тип",
    "uploadFile": "Загрузить файл",
    "newFolder": "Новая папка",
    "tableTime": "Время",
    "permission": "Недостаточно прав!",
    "notifyTitle": "Уведомление",
    "notifyContent": "У пользователя недостаточно прав для доступа!",
    "sortFileName": "Имя файла",
    "sortTime": "Время",
    "sortSize": "Размер",
    "sortType": "Тип",
    "moveTo": "Переместить в",
    "test": "Новый",
    "delTitle": "Удалить?",
    "delTitleContent": "Выбранный контент будет удален из базы данных. Операция не может быть отменена. Вы уверены, что хотите продолжить?",
    "delCancelButton": "Отменить",
    "delConfirmButton": "Подтвердить"
  },
  "userMge": {
    "userName": "Имя пользователя:",
    "jobNumber": "ID сотрудника:",
    "email": "Электронная почта:",
    "phone": "Телефон:",
    "group": "Группа:",
    "oldPassword": "Старый пароль:",
    "newPassword": "Новый пароль:",
    "confirmNewPassword": "Подтвердить новый пароль:",
    "btnSave": "Сохранить изменения",
    "titleChangePassword": "Изменить пароль",
    "titleMyProfile": "Мой профиль",
    "name": "Псевдоним:",
    "error1400": "Аккаунт (пользовательский) уже существует, операция не выполнена!",
    "error1401": "Аккаунт (сгенерированный системой) уже существует, операция не выполнена!",
    "error1402": "Группа не существует, импорт не удался!",
    "error1403": "Ошибка данных",
    "error1404": "Недостаточно прав",
    "selUser": "Пожалуйста, выберите пользователя!",
    "error1405": "Не удалось получить роль",
    "error1406": "Неверный формат данных импортированных сведений о пользователе",
    "error1407": "Электронная почта уже существует, операция не выполнена.",
    "error1408": "Телефон уже существует, операция не выполнена.",
    "editSuccess": "Успешно сохранено!",
    "ChangePassword": "Изменить пароль",
    "UserPrivacyAgreement": "Политика конфиденциальности пользователя"
  },
  "information": {
    "_2602": "Устройство оффлайн",
    "_2603": "Не удалось транслировать",
    "_2604": "Трансляция была прервана",
    "_2605": "Пространство для хранения данных заполнено",
    "_2606": "несколько минут назад",
    "_2607": "несколько часов назад",
    "_2609": "не удалось, пожалуйста, ",
    "_2609_a": "кликните здесь ",
    "_2609_time": "для своевременной обработки",
    "userType": "Администратор",
    "unreadNoticeFirst": "Сначала прочитайте уведомления",
    "sortByTime": "Сортировать по времени",
    "coxRead_1": "Прочитано",
    "coxRead_0": "Непрочитано",
    "allCoxRead": "Отметить все как прочитанное",
    "load": "Загрузка...",
    "noData": "Нет больше данных",
    "viewALLMessages": "Посмотреть ВСЕ уведомления"
  },
  "input": {
    "select": "Пожалуйста, выберите",
    "thisField": "Это поле должно быть заполнено.",
    "titleShooleNub60": "менее 60 символов",
    "titleShooleNub300": "менее 300 символов",
    "Offline": "Офлайн"
  },
  "schedule": {
    "OnlyManual": "Только вручную",
    "runStartNow": "Запустить задачу",
    "runStopNow": "Остановить задачу",
    "tackExecutionStart": "Задача в процессе",
    "tackExecutionStop": "Выполнение задачи остановлено",
    "dehumidification": "Обезвлаживание",
    "airSupply": "Подача воздуха",
    "masterControl": "основной:",
    "powerSupply": "Питание",
    "lockScreen": "Блокировка",
    "RecordingControl": "Управление записью",
    "RecordingControlSystem": "Система захвата лекций",
    "LiquidCrystal": "Интерактивный ЖК-дисплей",
    "projector": "Проектор",
    "othertype": "Другое",
    "childLock": "Блокировка детей",
    "energySaving": "Энергосбережение",
    "signalSourceSwitching": "Источник входа",
    "other": "Другие функции:",
    "otherFunction": "Функция",
    "send": "Отправить",
    "ON": "ВКЛ",
    "OFF": "ВЫКЛ",
    "btnAddSchedule": "Восстановить",
    "EditSchedulelist": "Редактировать расписание",
    "AddSchedulelist": "Добавить расписание",
    "RestoreSchedulelist": "Восстановить",
    "btn": "Отмена",
    "btnNewList": "Новое расписание",
    "ListName": "Имя",
    "Cannotquit": "Обязательно",
    "NOCannotquit": "НЕТ",
    "ListValidityPeriod": "Срок действия",
    "ListDescription": "Описание",
    "currentSchedule": "Список расписаний",
    "historySchedule": "Исторический список",
    "selectTime": "Время",
    "selectTimeTable": "Время",
    "taskType": "Тип задачи",
    "selectBroadcasting": "Трансляция",
    "selectDeviveControl": "Управление устройством",
    "newSchedule": "Новая задача",
    "newChecklist": "Новый список проверки",
    "titleStatus": "Статус",
    "titleType": "Тип",
    "titleStartTime": "Время начала",
    "titleEndTime": "Время окончания",
    "titleRepeat": "Повторить",
    "titleName": "Имя",
    "titleAction": "Действие",
    "tableEnabled": "Включено",
    "tablePaused": "Приостановлено",
    "tableEdit": "Редактировать",
    "tableDelete": "Удалить",
    "tableVolumeEdit": "Громкость трансляции",
    "tableBroadcastTitle": "Заголовок",
    "tableBroadcastContent": "Содержание",
    "tableBroadcastList": "Список",
    "tableBroadcast": "Обязательно",
    "btnRemoveCompletely": "Полностью удалить",
    "btnEnabled": "Включенная задача",
    "btnPaused": "Отключить задачу",
    "btnDelete": "Удалить",
    "repeat0": "ПН",
    "repeat1": "ВТ",
    "repeat2": "СР",
    "repeat3": "ЧТ",
    "repeat4": "ПТ",
    "repeat5": "СБ",
    "repeat6": "ВС",
    "dialogTitleAdd": "Новая задача управления устройствами",
    "dialogTitleEdit": "Редактировать задачу управления устройствами",
    "newBroadcastingSchedule": "Новая задача вещания",
    "editBroadcastingSchedule": "Редактировать задачу вещания",
    "chooseDevice": "Выбрать устройство",
    "timeSetting": "Настройка времени",
    "controlBroadcasting": "Опция вещания",
    "controlOption": "Опция управления",
    "scheduleName": "Название задачи:",
    "destination": "Назначение",
    "timeTilte": "Время",
    "repeatTitle": "Повторить",
    "dialogRepeat0": "ПН",
    "dialogRepeat1": "ВТ",
    "dialogRepeat2": "СР",
    "dialogRepeat3": "ЧТ",
    "dialogRepeat4": "ПТ",
    "dialogRepeat5": "СБ",
    "dialogRepeat6": "ВС",
    "dialogOnceType": "Один раз",
    "dialogRepeatType": "Повторить",
    "Manual": "Ручной",
    "ManualContent": "Вы можете вручную выполнить эти задачи после завершения настройки.",
    "mainPower": "Основное питание",
    "powerControl": "Управление питанием",
    "tableDisplayInputSwitch": "Переключение входа дисплея",
    "tableAirConditioning": "Кондиционер",
    "tableProjectionScreen": "Проекционный экран",
    "tableElectronicLock": "Электрический замок",
    "interactiveFlatPanel": "Интерактивная панель",
    "displayInputSwitch": "Переключение входа дисплея",
    "speakerVolume": "Громкость звука",
    "MICVolume": "Громкость микрофона",
    "ProjectionScreen": "Проекционный экран",
    "ElectronicLock": "Электрический замок",
    "AirConditioning": "Кондиционер",
    "AirConditioningPower": "Питание",
    "AirConditioningModel": "Модель",
    "AirConditioningTEMP": "Температура",
    "AirConditioningFanSpeed": "Скорость вентилятора",
    "OPEN": "ОТКРЫТЬ",
    "CLOSE": "ЗАКРЫТЬ",
    "UP": "ВВЕРХ",
    "DOWN": "ВНИЗ",
    "PowerOFF": "ВЫКЛЮЧЕНО",
    "PowerON": "ВКЛЮЧЕНО",
    "ModelAuto": "Авто",
    "ModelCool": "Охлаждение",
    "ModelHeat": "Нагрев",
    "ModelAir": "С воздушной стороны",
    "TEMPLow": "Низкий",
    "TEMPMiddle": "Средний",
    "TEMPHigh": "Высокий",
    "btnSave": "Сохранить",
    "btnNext": "ДАЛЕЕ",
    "StartTime": "Время начала",
    "StopTime": "Время окончания",
    "Mandatory": "Обязательный",
    "Video": "Видео и Аудио",
    "Notification": "Уведомление",
    "btnFile": "Выбрать медиофайл",
    "LastingTime": "Продолжительность",
    "textTitle": "Заголовок",
    "textContent": "Содержание",
    "textTitleLetters": "Менее 60 символов",
    "textContentLetters": "Менее 320 символов",
    "CannotquitYES": "ДА",
    "CannotquitNo": "Нет",
    "YES": "Вы уверены, что хотите удалить этот планировщик?",
    "No": "Удаленный планировщик будет перемещен в список истории и может быть восстановлен",
    "delTitleContent": "Удалить планировщик?",
    "delTitleListContent": "Удаление планировщика приведет к очистке связанных с ним задач, пожалуйста, подтвердите.",
    "deleListTitle": "Вы уверены, что хотите удалить этот планировщик?",
    "delTitleListContent1": "Удалить?",
    "deleListTitle1": "Подтвердить",
    "delTitle": "ВСЕ",
    "btnConfirm": "Трансляция",
    "coxAll": "Управление устройством",
    "coxBroadcasting": "ДА",
    "coxDeviveControl": "НЕТ",
    "rdMandatory": "Дата начала",
    "noRdMandatory": "Дата окончания",
    "startDate": "-",
    "endedDate": "Тип",
    "or": "Выберите время",
    "broadcastingType": "Выберите дату",
    "ChooseTime": "Новый планировщик",
    "ChooseDate": "Редактировать планировщик",
    "newScheduleList": "Имя",
    "editScheduleList": "Срок действия",
    "listName": "Описание",
    "listValidityPeriod": "Отмена",
    "listDescription": "Подтвердить",
    "cancel": "Отмена",
    "confirm": "Подтвердить",
    "save": "Сохранить",
    "addSuccess": "Успешно добавлено!",
    "addError": "Ошибка при добавлении!",
    "editSuccess": "Успешно отредактировано!",
    "editError": "Ошибка при редактировании!",
    "delSuccess": "Успешно удалено!",
    "delError": "Ошибка при удалении!",
    "restoreSuccess": "Список расписаний успешно восстановлен",
    "restoreError": "Не удалось восстановить список расписаний",
    "restoreTitleContent": "Это время конфликтует с временем в списке расписаний, выберите снова",
    "Enabled": "Включено",
    "Paused": "Приостановлено",
    "Title": "Заголовок:",
    "Content": "Содержание:",
    "errorScheduleNameRequired": "Название задачи должно быть заполнено",
    "errorDeviceRequired": "Пожалуйста, выберите целевое устройство",
    "deleTitle": "Вы уверены, что хотите удалить эту задачу?",
    "loopList": "Список циклов",
    "errorPleaseDateRange": "Пожалуйста, выберите диапазон дат",
    "addError_2009": "Дублированное имя планировщика",
    "conflicts": "Время задачи конфликтует с следующим:",
    "Pleaseagain": "Пожалуйста, введите снова",
    "errorScheduleName": "Название задачи",
    "errorListName": "Название планировщика",
    "today": "Сегодня",
    "yesterday": "Вчера",
    "thisWeek": "Эта неделя",
    "lastWeek": "Прошлая неделя",
    "lastMonth": "Прошлый месяц",
    "thisMonth": "Этот месяц",
    "times": "Раз",
    "TimeConflicts": "Конфликты времени",
    "editError_2006": "Устройство не найдено",
    "editError_2010": "Дублированное имя задачи",
    "editError_2100": "Задача истекла, не может быть запущена.",
    "ListTimeExpired": "Время планировщика истекло, выберите снова",
    "TimeExpired": "Время истекло",
    "ControlOption": "Отсутствует опция управления",
    "Pleaseleastone": "Пожалуйста, выберите хотя бы одну опцию управления",
    "Enter": "Ввод",
    "TitleFilled": "Заголовок должен быть заполнен",
    "ContentFilled": "Содержание должно быть заполнено",
    "PleaseMediaFile": "Пожалуйста, выберите медиафайл",
    "PleaseSchedule": "Пожалуйста, выберите задачу",
    "delTitleScheduleContent": "Удаленная задача не может быть восстановлена.",
    "deleTitleSchedule": "Вы уверены, что хотите удалить эту задачу?",
    "deleteScheduleTitle": "Пожалуйста, выберите задачу для удаления",
    "PleaseFillColumn": "Пожалуйста, заполните имя планировщика",
    "PleaseDate": "Пожалуйста, выберите дату",
    "Previous": "Предыдущий",
    "RemoteControl": "Удаленное управление",
    "taskhasexpired": "Задача истекла, пожалуйста, свяжитесь с создателем, чтобы обновить время.",
    "execute": "Выполнить",
    "broadcastingList": "Список трансляции",
    "volumeSuccess": "Громкость успешно установлена",
    "volumeFailed": "Не удалось установить громкость"
  },
  "live": {
    "StreamingRoom": "Комната для трансляций",
    "btnAddNewRoom": "Добавить новую комнату",
    "Steaming": "Трансляция",
    "Creater": "хост:",
    "Address": "RTMP-адрес:",
    "StreamingURL": "URL для живой трансляции:",
    "DestinationNMP": "Выберите пункт назначения NMP:",
    "stop": "СТОП",
    "stat": "СТАРТ",
    "btnCope": "Нажмите, чтобы СКОПИРОВАТЬ",
    "QRcode": "QR код",
    "Refresh": "Обновить",
    "AddNewRoomTitle": "Добавить новую комнату для трансляций",
    "editNewRoomTitle": "Редактировать комнату для трансляций",
    "roomName": "Название комнаты:",
    "cancel": "Отменить",
    "confirm": "Подтвердить",
    "save": "Сохранить",
    "delTitleContent": "Вы уверены, что хотите удалить этот график?",
    "delTitle": "Удалить?",
    "delCancelButton": "Отменить",
    "delConfirmButton": "Подтвердить",
    "addSuccess": "Успешно добавлено!",
    "addError": "Не удалось добавить!",
    "editSuccess": "Успешно отредактировано!",
    "editError": "Не удалось отредактировать!",
    "delSuccess": "Успешно удалено!",
    "delError": "Не удалось удалить!",
    "Stopstreaming": "Остановить трансляцию",
    "Startstreaming": "Начать трансляцию",
    "error2504": "Не удалось получить адрес для живой трансляции с медиа-сервера",
    "error2505": "Дублирующееся имя комнаты для трансляций",
    "error2506": "Устройство занято другим потоком трансляции",
    "error1900": "Полученный параметр пуст",
    "error2503": "Не удалось получить информацию о медиа-сервере",
    "error2507": "Дублирующийся адрес для живой трансляции",
    "copySuccess": "Контент был скопирован в буфер обмена.",
    "copyError": "Браузер не поддерживает автоматическое копирование",
    "flashControl": "Flash не установлен или не активирован. Пожалуйста, попробуйте снова после установки или активации Flash.",
    "liveStreaming": "Источник для живой трансляции не найден.",
    "btnflash": "Установить/Активировать",
    "serverAddress": "Адрес сервера",
    "addressKey": "Ключ:",
    "watchingAddress": "Адрес для просмотра",
    "audioOnly": "Только аудио",
    "enterTheKey": "Ключ должен быть заполнен."
  },
  "guidepages": {
    "next": "Следующее устройство управления",
    "next1": "Следующая попытка управления",
    "next2": "Следующая трансляция",
    "next3": "Следующее начало трансляции",
    "next4": "Следующее остановить трансляцию",
    "next5": "Следующее текстовая трансляция",
    "next6": "Следующая настройка задачи",
    "next7": "Следующее добавить новую задачу",
    "next8": "Следующий список истории",
    "next9": "Следующее облачное хранилище",
    "next10": "Следующее прямой эфир",
    "next11": "Следующее настройка прямого эфира",
    "exit": "Выход",
    "guideContent": "Содержание справки",
    "btnHomepage": "Главная страница",
    "btnDevices": "Устройства",
    "btnBroadcast": "Трансляция",
    "btnSchedule": "Расписание",
    "btnResources": "Ресурсы",
    "btnStreaming": "Стриминг",
    "btnPrevious": "Предыдущий"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    }
}



// WEBPACK FOOTER //
// ./src/lang/ru.js